import { useSelector } from 'react-redux'
import { IS_GBSTORAGE, PLAN_ACTIVE } from '@disco/constants/FeatureTypes'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'
import { getSubscriptionPeriod } from '@disco/state-management/selectors/subscription'

/**
 * Hook to determine if the user can change add-ons based on their plan and business settings.
 * Checks if the plan is active, not GB storage, and not a bank draft subscriber.
 * For DS (Data Science) add-ons, also verifies trial consistency.
 * @param params - Optional parameters object
 * @param params.isDS - Whether to check for Data Science add-on specific rules
 * @returns True if the user can change add-ons, false otherwise
 * @see https://app.asana.com/0/0/1200878373457006/f
 * @todo Replace IS_GBSTORAGE with SELF_SERVE_ADDONS_CHANGE
 */
export const useEnableChangeAddOns = (
  params: {
    isDS?: boolean
  } = {},
): boolean => {
  // The logic is described in the task https://app.asana.com/0/0/1200878373457006/f
  const {
    plan_type,
    // @ts-expect-error state is untyped
  } = useSelector(state => state.user?.business?.private_metadata || {})
  const planActive = useFeatureEnabled(PLAN_ACTIVE)
  const isGbstorage = useFeatureEnabled(IS_GBSTORAGE) // TODO: replace IS_GBSTORAGE with SELF_SERVE_ADDONS_CHANGE
  const subscriptionPeriod = useSelector(getSubscriptionPeriod)

  if (!subscriptionPeriod) return false // TODO: enable billing on 2-year subscriptions

  const isBankDraftSubscriber = plan_type === 'bank_draft_subscriber'
  const result = planActive && !isGbstorage && !isBankDraftSubscriber

  return result
}
